import { makeStyles } from "@material-ui/core/styles";
export default makeStyles((theme) => ({
  marginLeftAuto: {
    marginLeft: "auto",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    //   boxShadow: theme.shadows[5],
    padding: "25px 30px 30px",
    borderRadius: "1.5625rem",
    outline: "none",
    position: "relative",
    width:  props => props.width?props.width:"325px",
    marginLeft: "10px",
    marginRight: "10px",
    boxShadow: "4px 4px 40px rgba(0, 0, 0, 0.6)",
    "@media (max-width:550px)": {
      padding: "25px 16px",
      fontSize: "14px",
    },
  },
  connectWallet: {
    display: "flex",
  },
  closeIcon: {
    marginRight: "auto",
    right: "26px",
    top: "26px",
    position: "absolute",
    cursor:"pointer",
    padding: "5px",
    zIndex:"1",
    transform: "scale(1.2)",
        borderRadius:"100px",
    "&:hover": {
    backgroundColor: "#ebe7e7",
  },
  },
  connectWalletText: {
    fontSize: "1.3625rem",
    fontWeight: "600",
    fontFamily: "Inter",
    padding: "20px 0px",
    "@media (max-width:550px)": {
      padding: " 14px 0px",
      fontSize: "1.0625rem",
    },
  },
  walletList: {
    // display:"flex",
    // padding:"10px 15px",
  },
  walletItem: {
    background: "#E7EEFF",
    borderRadius: "12px",
    padding: "10px 15px",
    margin: "10px 0px",
    // display: "flex",
    fontSize: "1.125rem",
    fontFamily: "Mulish",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: "18px",
    alignItems: "center",
    color: "#282828",
  },
  WalletIcon: {
    marginLeft: "auto",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: "15px",
    lineHeight: "19px",
    color: "#282828",
    background: "#FFDF00",
    borderRadius: "50px",
    padding: "8px 15px",
  },
  accountDetailsDiv: {
    paddingTop: "10px",
  },
  disconnectFunctions: {
    fontStyle: "normal",
    fontWeight: "normal",
    display: "flex",
    fontSize: "14px",
    lineHeight: "18px",
    /* identical to box height */

    /* Wireframe/Blue/Secondary */

    color: " #282828",

    /* Inside Auto Layout */

    flex: "none",
    order: "1",
    flexGrow: "0",
  },
  accountAddress: {
    fontStyle: "normal",
    fontWeight: "900",
    fontSize: "20px",
    lineHeight: "25px",
    // textShadow: "0px 0px, 0.1px 0.1px, 0.1px 0.1px",
    /* identical to box height */

    /* Wireframe/Blue/Secondary */

    color: "#282828",
  },
  backDrop: {
    backdropFilter: "blur(10px)",
    backgroundColor: "rgba(150, 150, 150, 0.4)",
  },
  disconnectFunctionsItem: {
    margin: "10px 0px",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  disconnectWalletTitle: {
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "15px",
    lineHeight: "19px",
    color: "#282828",

    opacity: " 0.8",
  },
  Link:{
    textDecorationColor:"rgb(105, 105, 105)",
    color: "rgb(105, 105, 105)" ,
    display:"flex",
    marginTop:"10px",
    justifyContent:"center",
    "&:hover":{
        "& span img":{
          filter:"invert(27%) sepia(0%) saturate(2878%) hue-rotate(346deg) brightness(70%) contrast(97%)",
        },
      // textShadow: "4px 4px 40px rgba(0, 0, 0, 0.6)",
      textDecorationColor:"black",
      color:"black"
    }
  }
}));
